<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Payment Link"
            bc1="App"
            bc2="Transactions"
            bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$emit('backFromDetailPage')"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="mr-2 mt-1" >
            <div class="row">
              <div class="col-md-12 col-12">
                <div  class=" d-flex flex-row-reverse">
                  <div class="mb-1">
                    <button  type="button" class="btn-sm btn btn-gradient-success mr-1" @click="exportData('excel')">
                      <div v-show="excelLoader"  class="spinner-border text-white spinner-border-sm mr-1"></div>
                      <feather type="file-text"></feather>
                      Export Excel
                    </button>
                    <button  type="button" class="btn-sm btn btn-gradient-danger" @click="exportData('pdf')">
                      <div v-show="pdfLoader" class="spinner-border text-white spinner-border-sm mr-1"></div>
                      <feather type="file-text"></feather
                      >
                      Export PDf
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12">
              <div class="card">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>UUID</th>
                        <th>Reference Id</th>
                        <th>Getway Reference Id</th>
                        <th>Sender Account Number</th>
                        <th>Sender Account Title</th>
                        <th>Reciever Account Number</th>
                        <th>Reciever Account Title</th>
                        <th>Amount</th>
                        <th>Fees</th>
                        <th>VAT</th>
                        <th>Payable Amount</th>
                        <th>Exchange Rate</th>
                      </tr>
                    </thead>
                    <tbody v-if="transactionData">
                      <tr v-for="(item, index) in transactionData.transactions" :key="index">
                        <td style="cursor: pointer"  @click="$router.push({name: 'transactions-detail',params: {id:item.uuid}})">{{ item.uuid }}</td>
                        <td>{{ item.reference_id }}</td>
                        <td>{{ item.gateway_reference_id }}</td>
                        <td>{{ item.sender_account_number }}</td>
                        <td>{{ item.sender_account_title }}</td>
                        <td>{{ item.receiver_account_number }}</td>
                        <td>{{ item.receiver_account_title }}</td>
                        <td>{{ modifyAmount(parseFloat(item.amount/100).toFixed(amountDecimalPlaces)) }}</td>
                        <td>{{ parseFloat(item.fee/100).toFixed(feesDecimalPlaces) }}</td>
                        <td>{{ parseFloat(item.vat/100).toFixed(feesDecimalPlaces) }}</td>
                        <td>{{ modifyAmount(parseFloat((item.amount-item.vat-item.fee)/100).toFixed(amountDecimalPlaces)) }}</td>
                        <td>{{ item.exchange_rate?item.exchange_rate:'N/A' }}</td>
                      </tr>
                      <tr v-if="!innertransaction.length">
                        <td
                          colspan="11"
                          class="font-weight-bolder font-medium-2"
                          style="text-align: center"
                        >
                          No Data Avaliable
                        </td>
                      </tr>
                      <!--<template v-if="!transactionData.length"
                        >No data Available
                      </template>-->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


import {mapState} from "vuex";

export default {

  props: ['rowData'],
  mounted() {

    this.transactionData = this.rowData
    this.innertransaction = this.transactionData.transactions


  },
  data() {
    return {
      transactionData: [],
      innertransaction:[]
    };
  },
  methods: {
    exportData(exportType){
      let requestData = {
        exportAs: exportType,
        reportType: 'payment_link_transactions',

      }
      if(this.transactionData){
        requestData.token = this.transactionData.token
      }

      this.downloadReport(requestData)
    }
  },
  computed: {
    ...mapState(['excelLoader','pdfLoader']),
  }
};
</script>
